import api from './api';

const budgetReportsService = {
  // Get budget vs actual expense reports
  getBudgetReports: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.categoryId) params.append('categoryId', filters.categoryId);
      if (filters.department) params.append('department', filters.department);
      if (filters.employeeId) params.append('employeeId', filters.employeeId);

      const queryString = params.toString();
      const url = `/budget-reports/reports${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting budget reports:', error);
      throw error;
    }
  },

  // Get budget filter options
  getBudgetFilterOptions: async () => {
    try {
      const response = await api.get('/budget-reports/filters');
      return response.data;
    } catch (error) {
      console.error('Error getting budget filter options:', error);
      throw error;
    }
  }
};

export default budgetReportsService;

